/**
 * @param {object} event
 * @param {string} event.detail.name The field name of the input.
 * @param {string} event.detail.value The value of the input.
 * @param {object} event.detail.element A jQuery object representing the element that added to the DOM (this is the parent <div> that wraps the input and label).
 * @param {object} event.detail.fieldConfig 
 * @param {boolean} event.detail.hasConditionalLogic True if the field utilizes conditional logic.
 * @param {boolean} event.detail.hasBundledProducts True if the field has product bundles attached in it's initial state.
 */
"Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);

// @start switch around infinite option labels
window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
  subscribe('fieldLoad', function(event) {
    event.detail.element[0].querySelectorAll('span label').forEach(function(el, index) {
      let labelEl  = el;
      let inputEl  = el.querySelector('input');
      let newAttr  = event.detail.name+'-'+index;
      let parentEl = el.parentNode;
      let containerEl = document.createElement('div');

      // Set required atts
      labelEl.setAttribute('for', newAttr);
      inputEl.setAttribute('id', newAttr);

      // Move input before label
      parentEl.insertBefore(inputEl, labelEl);

    });
  });
};
// @end switch around infinite option labels

// @start changes to RFQ form page
document.addEventListener('GRFQ_quote_page_loaded', function() {
  const rfqItems = document.querySelectorAll('.rfq_form_page .item_option li');
  const optionsHead = document.querySelector('.rfq-table thead th.option');
  const optionsBody = document.querySelector('.rfq-table tbody td.td_option');
  const invisibilityClass = 'invisible';

  if(rfqItems.length) {
    optionsHead.classList.remove(invisibilityClass);
    optionsBody.classList.remove(invisibilityClass);
    rfqItems.forEach(function(el, i) {
      const currentTxt = el.innerText;
      const regex = /,(\S)/gi;
      el.innerText = currentTxt.replace(regex, ', $1');
    });
  } else {
    optionsHead.classList.add(invisibilityClass);
    optionsBody.classList.add(invisibilityClass);
  }
}, false);
// @end changes to RFQ form page

// @start show/hide appropriate phone #
const phonesCont = document.querySelector('.header--phones');
const setGeoPhoneAndHire = function() {
  var localCountry   = localStorage.getItem('countryCode');
  const allPhones    = document.querySelectorAll('.header--phone');
  const defaultPhone = document.querySelector('.header--phone-default');
  const nzPhone      = document.querySelector('.header--phone-nz');
  const auPhone      = document.querySelector('.header--phone-au');
  const hiddenClass  = 'hidden';
  
  if(!localCountry) {
    geoip2.country(function(location) {
      const countryCode  = location.country.iso_code.toLowerCase();
      localStorage.setItem('countryCode', countryCode);
      localCountry = countryCode;
    }, function(error) {
      console.log("Error:\n\n" + JSON.stringify(error, null, 2));
    });
  }

  if(localCountry) {
    if('nz' == localCountry) {
      defaultPhone.classList.add(hiddenClass);
      nzPhone.classList.remove(hiddenClass);
      auPhone.classList.add(hiddenClass);
    } else if('au' == localCountry) {
      defaultPhone.classList.add(hiddenClass);
      nzPhone.classList.add(hiddenClass);
      auPhone.classList.remove(hiddenClass);
    } else {
      defaultPhone.classList.remove(hiddenClass);
      nzPhone.classList.add(hiddenClass);
      auPhone.classList.add(hiddenClass);
    }
  } else {
    defaultPhone.classList.remove(hiddenClass);
    nzPhone.classList.add(hiddenClass);
    auPhone.classList.add(hiddenClass);
  }

  if('nz' != localCountry) {
    const navEls = document.querySelectorAll('.Header__MainNav .HorizontalList__Item, .SidebarMenu__Nav--primary > .Collapsible');
    navEls.forEach(function(el, index) {
      const elHref = el.querySelector('a').getAttribute('href').toLowerCase().trim();
      if('/collections/neilo-hire' == elHref || '/collections/neilo-hire/' == elHref) {
        el.classList.add(hiddenClass);
      }
    });
  }
  
};

setGeoPhoneAndHire();
// @end show/hide appropriate phone #

// @start animate phone #
const startShaking = function() {
  const imgAnime = document.querySelector('.header--phone:not(.hidden) img');
  imgAnime.style.setProperty('--animate-delay', '5s');
  imgAnime.classList.add('animate__animated', 'animate__shakeY');
  imgAnime.addEventListener('animationend', () => {
    imgAnime.classList.remove('animate__animated', 'animate__shakeY');
    setInterval(function() {
      imgAnime.classList.add('animate__animated', 'animate__shakeY');
    }, 30000);
  });

};
window.addEventListener('DOMContentLoaded', (event) => {
  var tl = new TimelineLite({ onComplete: startShaking, delay: window.themeVariables.settings.showPageTransition ? 0.5 : 0 });
  tl.fromTo(phonesCont, 1, {autoAlpha: 0, x: -100}, {autoAlpha: 1, x: 0, delay: 0.45});
});
// @end animate phone #
